import moment from 'moment-timezone';
import { getDefaultGymName } from '../config';
import { GymTypes } from 'fitbeat.models';
import { GymResolver } from '../services';

export const getGymTimezone = (workoutSession) => {
  if (workoutSession) {
    return getTimezoneFromGymName(workoutSession.gymName);
  }
  const defaultGym = getDefaultGym();
  return defaultGym.timezone;
}

export const getTimezoneFromGymName = (gymName) => {
  const gym = GymResolver.getByName(gymName);
  if (gym.type === GymTypes.Home) {
    return moment.tz.guess();
  }
  return gym.timezone;
}

export const getDefaultGym = () => {
  const defaultGymName = getDefaultGymName();
  if (!defaultGymName) {
    alert(`defaultGymName not set, app will crash`);
    return;
  }

  return defaultGymName;
}
